define('controllers/goods-card',['require','chaplin','models/modals/goods-card/index','views/modals/goods-card/index'],function(require) {
    'use strict';

    var Chaplin = require('chaplin'),
        GoodsCardModel = require('models/modals/goods-card/index'),
        GoodsCardView = require('views/modals/goods-card/index');


    function openGoodsCard(params) {

        // title: this.model.get('fullName'),
        // tradeId: this.model.get('tradeId'),
        // organizationOfferId: this.model.get('idOrganizationOffer'),
        // tradeGoodsId: this.model.get('idTradeGoods'),

        var model = new GoodsCardModel(params);

        return new GoodsCardView({ model: model });
    }


    Chaplin.mediator.setHandler('openGoodsCard', openGoodsCard);

});
